import type { SVGProps } from "react";
export interface FaceMaskIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function FaceMaskIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: FaceMaskIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.875 6.75c0-.397-.293-.625-.541-.625s-.542.228-.542.625v6.38l.265-.177.177-.138c.394-.347.64-.874.64-1.455V6.75Zm-9.273-.625c-.403 0-.801.1-1.163.293l-.152.09c-1.083.68-2.204 1.334-3.828 1.545v5.187c0 1.484.604 2.745 1.616 3.342l.45.255c1.08.58 2.312 1.038 3.476 1.038 1.329 0 2.748-.597 3.925-1.293l.185-.12c.9-.636 1.431-1.831 1.431-3.222V8.053c-1.377-.179-2.392-.675-3.33-1.238l-.498-.308a2.47 2.47 0 0 0-1.316-.382zM3.125 11.36c0 .663.323 1.259.819 1.593l.265.177V6.75c0-.397-.294-.625-.542-.625s-.542.228-.542.625zm20 0a4.18 4.18 0 0 1-1.603 3.308l-.21.15-2.222 1.495a5.3 5.3 0 0 1-1.677 1.985l-.343.221c-1.302.77-3.141 1.605-5.07 1.606-1.687 0-3.307-.64-4.558-1.316l-.513-.29c-.914-.54-1.577-1.319-2.021-2.206l-2.221-1.494C1.544 14.049.875 12.74.875 11.36V6.75c0-1.535 1.2-2.875 2.792-2.875 1.252 0 2.257.83 2.63 1.93 1.07-.165 1.845-.607 2.791-1.202l.289-.168a4.7 4.7 0 0 1 2.225-.56h.796c.888 0 1.758.252 2.515.728l.44.272c.76.457 1.45.791 2.347.93.374-1.101 1.381-1.93 2.634-1.93 1.593 0 2.79 1.34 2.79 2.875v4.61Z"
      />
      <path
        fill={color}
        d="M15.288 12.896a1.125 1.125 0 0 1 .535 2.182l-.52.152c-.644.177-1.682.394-3.304.394s-2.659-.217-3.303-.394l-.52-.152-.108-.04a1.126 1.126 0 0 1 .643-2.143l.113.027.432.13c.528.147 1.365.322 2.743.322 1.838 0 2.715-.313 3.178-.452zM12 8.375c1.622 0 2.66.217 3.304.394l.52.154.108.038a1.125 1.125 0 0 1-.643 2.144l-.111-.027-.434-.13c-.528-.146-1.366-.323-2.744-.323-1.836 0-2.712.314-3.175.453a1.126 1.126 0 0 1-.648-2.155c.537-.161 1.66-.548 3.823-.548"
      />
    </svg>
  );
}
